<template>
  <div>
    <h3>All Sites</h3>

    <b-form-select
      v-model="tagId"
      :options="selectTags"
      class="mt-3 mb-3"
    >
      <template v-slot:first>
        <option value="">{{ $t("site.tagfilter") }}</option>
      </template>
    </b-form-select>

    <ul>
      <site-detail-sitelist-item v-for="site in filteredSites" :key="site.id" v-bind="site" />
    </ul>
  </div>
</template>
<script>

import { mapState, mapActions, mapGetters } from 'vuex'

import SiteDetailSitelistItem from './SiteDetailSitelistItem'

export default {
  name: 'SiteDetailSitelist',
  data () {
    return {
      tagId: ''
    }
  },
  components: {
    SiteDetailSitelistItem
  },
  computed: {
    ...mapState('site', { sites: state => state.allSitesList.data }),

    ...mapGetters('tag', ['selectTags']),

    filteredSites: function () {
      if (!this.tagId) {
        return this.sites
      }

      return this.sites.filter((site) => {
        return site.tags.find(siteTag => siteTag.id === this.tagId)
      })
    }
  },
  methods: {
    ...mapActions('site', [
      'getAllSites'
    ])
  },
  mounted () {
    this.getAllSites()
  }
}
</script>
